import React, { Fragment } from 'react';
import Banner from '../../../components/Banner/index';
import Footer from '../../../components/Footer/index';
import Sidebar from '../../../components/Sidebar/index';
import ArtistAnalytics from './Artist';
import { IsArtist } from '../../../utils/Roles';

class Analytics extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isArtist: IsArtist(),
    };
  }

  onLogout = () => {
    this.props.history.push('/login');
  };

  render() {
    const { isArtist } = this.state;

    return (
      <div>
        <Banner />
        <div className="my-propertiess">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-12">
                <Sidebar active="analytics" onLogout={this.onLogout} />
              </div>
              <div className="col-lg-9 col-md-9 col-sm-12">
                {(isArtist) && (
                  <Fragment>
                    <ArtistAnalytics />
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Analytics;



// WEBPACK FOOTER //
// ./src/containers/Artist/Analytics/index.js